<div class="dialog-header py-8">
  <h2 class="dialog-title text-gray-800">
    {{ "ONLINE_CLASS.COMMENT_TITLE" | translate }}
    <!-- <app-keenicon
      name="arrow-left"
      class="fs-2 cursor-pointer"
      type="solid"
    ></app-keenicon> -->
    <!-- {{ "APP.CONFIRM_SHIFT_EXIT" | translate }} -->
  </h2>
  <button
    type="button"
    aria-label="Close"
    class="btn-close"
    (click)="onClose()"
  ></button>
</div>
<div class="dialog-content py-6 text-start text-gray-800" [formGroup]="form">
  <div class="">
    <div class="pb-0">
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center flex-grow-1">
          <div class="symbol symbol-circle symbol-45px me-5">
            <!-- `currentUser.data.image_url` is the raw, relative path from
                 `/users/current` — `UserModel.setUser` (which would have made
                 it absolute) is never actually called anywhere in this app,
                 so it still needs `fileUrl` here. No `blank.png` though: a
                 person icon instead, like every other avatar placeholder on
                 the site. -->
            @if (currentUser?.data?.image_url) {
            <img [src]="fileUrl + currentUser?.data?.image_url" class="object-fit-cover" [attr.alt]="currentUser?.data?.full_name" />
            } @else {
            <span class="symbol-label bg-light-primary text-primary">
              <app-keenicon name="user" class="fs-2 text-primary"></app-keenicon>
            </span>
            }
          </div>

          <div class="d-flex flex-column">
            <a class="text-gray-900 text-hover-primary fs-6 fw-semibold">{{
              currentUser?.data?.full_name
            }}</a>

            <span class="text-gray-500 fw-bold">{{ currentUser?.email }}</span>
          </div>
        </div>
        <div>
          <label class="fw-semibold mb-1">{{
            "ONLINE_CLASS.COMMENT_RATING" | translate
          }}</label>
          <app-rating-star
            [modeForm]="true"
            [rating]="form.value.score"
            formControlName="score"
            iconSize="fs-2"
          ></app-rating-star>
        </div>
      </div>

      <div class="ql-quil ql-quil-plain">
        <div class="pt-6 ql-container ql-snow">
          <div class="ql-editor ql-blank">
            <!-- The key did not exist, so the placeholder printed the key
                 itself: a visitor asked to review a course was shown the
                 literal text "COMMENT.PLACEHOLDER". It lives under
                 ONLINE_CLASS.* -->
            <app-textarea
              name="review"
              formControlName="review"
              placeholder="ONLINE_CLASS.COMMENT_PLACEHOLDER"
              [labelMode]="LabelMode.NO_LABEL"
              minHeightClass="min-h-150px"
              [required]="true"
              [error]="error?.review"
            ></app-textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-footer gap-4">
  <button
    class="btn btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800 col-12 col-sm-auto"
    (click)="onClose()"
  >
    {{ "COMPONENT.CANCEL" | translate }}
  </button>
  <button
    class="btn btn-primary btn-get-started px-10 col-12 col-sm-auto"
    (click)="onSubmit()"
  >
    {{ "ONLINE_CLASS.COMMENT_SUBMIT" | translate }}
  </button>
</div>
